import React, { useState } from "react";
import { FaFileExcel } from "react-icons/fa";
import { getBrandColors, darken } from "../ThemeContext";
import API_BASE from "../apiConfig";

/**
 * Branded "Download Excel" button. Fetches `endpoint` (relative to API_BASE, with
 * `params` as a query string) as a blob and saves it client-side — no page navigation,
 * so the session/Authorization header handling in apiConfig.js's fetch patch applies.
 */
export default function ExcelDownloadButton({ endpoint, params = {}, filename, label = "Download Excel", disabled = false }) {
  const [loading, setLoading] = useState(false);
  const y = getBrandColors().yellow;

  const handleClick = async () => {
    if (loading || disabled) return;
    setLoading(true);
    try {
      const qs = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
      ).toString();
      const res = await fetch(`${API_BASE}${endpoint}${qs ? "?" + qs : ""}`);
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = filename || "export.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      window.alert("Export failed — please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button onClick={handleClick} disabled={loading || disabled} title={label} style={{
      display: "flex", alignItems: "center", gap: 7,
      padding: "8px 16px", borderRadius: 9, border: "none",
      background: `linear-gradient(135deg, ${y}, ${darken(y)})`,
      color: "#1a1300", fontWeight: 800, fontSize: 12,
      cursor: loading || disabled ? "default" : "pointer",
      opacity: loading || disabled ? 0.6 : 1,
      boxShadow: `0 3px 10px ${y}44`,
      whiteSpace: "nowrap",
    }}>
      <FaFileExcel size={13} />
      {loading ? "Preparing…" : label}
    </button>
  );
}
